import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { STATE_LAW_API } from "./apiRoutes";

interface UseGetStateLawsProps {
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getStateLaws = async (data: any) =>
  await axiosAuth.post(`${STATE_LAW_API}/grid`, data);

const useGetStateLaws = ({
  data,
  queryParams,
}: UseGetStateLawsProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["state-law"],
    queryFn: () => getStateLaws(data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: (queryParams?.enabled ?? true),
  });
};

export default useGetStateLaws;
